export default __webpack_public_path__ + "static/media/upload.ad3682fd.less";